import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import { DataLoader } from '@fibo-app/fibo-collab-shared'

class FirebaseCalendarEvents extends React.Component {

  eventsLoaders : { [string]: DataLoader }

  static propTypes = {
    events: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props : Object) {
    super(props)
    this.eventsLoaders = {}
    this.checkEvents(undefined, props.events)
  }

  componentWillReceiveProps(nextProps) {
    this.checkEvents(this.props.events, nextProps.events)
  }

  checkEvents(currEvents, nextEvents) {
    const oldEvents = []
    const newEvents = []

    // Detect the changes (new & old events)
    for (const combinedId in nextEvents) {
      if (!currEvents.hasOwnProperty[combinedId]) {
        newEvents.push(nextEvents[combinedId])
      }
    }
    for (const combinedId in currEvents) {
      if (!nextEvents.hasOwnProperty[combinedId]) {
        oldEvents.push(currEvents[combinedId])
      }
    }
    // Start syncing new events and stop syncing old events
    for (let i = 0; i < oldEvents.length; i++) {
      this.stopSyncingEvent(oldEvents[i])
    }
    for (let i = 0; i < newEvents.length; i++) {
      this.startSyncingEvent(newEvents[i])
    }
  }

  startSyncingEvent(eventInfo) {
    const eventLoader = new DataLoader(firebase, 'events', 'commonInfo')
    this.props.dispatch(eventLoader.startSyncing(eventInfo.eventId))
    this.eventsLoaders[eventInfo.eventId] = eventLoader
  }

  stopSyncingEvent(eventInfo) {
    if (this.eventsLoaders.hasOwnProperty(eventInfo.eventId)) {
      this.eventsLoaders[eventInfo.eventId].stopSyncing()
      delete this.eventsLoaders[eventInfo.eventId]
    }
  }

  render() {
    return null
  }

}

function mapStateToProps(state) {
  return {
    events: state.schedule.events
  }
}

export default connect(mapStateToProps)(FirebaseCalendarEvents)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseCalendarEvents.js